import $ from 'jquery';
import { format, isAfter, isBefore, differenceInSeconds, parse, isEqual } from 'date-fns';
import { formatInTimeZone, toZonedTime } from 'date-fns-tz';

const DateFns = {
  format,
  formatTZ: (date, tz, format) => {
    if (typeof date === 'number') date = date * 1000;
    return formatInTimeZone(date, tz, format);
  },
  isAfter,
  isBefore,
  differenceInSeconds,
  toZonedTime,
  parse,
  isEqual,
};

$.DateFns = DateFns;

export default DateFns;
